var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcSocYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "#36F6FF",
    fillOpacity: 0.5,
    stroke: "#36F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 21.2503L21.4559 18.0003L15.8334 14.7503V21.2503ZM28.3567 12.7678C28.4976 13.277 28.5951 13.9595 28.6601 14.8262C28.7359 15.6928 28.7684 16.4403 28.7684 17.0903L28.8334 18.0003C28.8334 20.3728 28.6601 22.117 28.3567 23.2328C28.0859 24.2078 27.4576 24.8362 26.4826 25.107C25.9734 25.2478 25.0417 25.3453 23.6117 25.4103C22.2034 25.4862 20.9142 25.5187 19.7226 25.5187L18.0001 25.5837C13.4609 25.5837 10.6334 25.4103 9.51758 25.107C8.54258 24.8362 7.91425 24.2078 7.64341 23.2328C7.50258 22.7237 7.40508 22.0412 7.34008 21.1745C7.26425 20.3078 7.23175 19.5603 7.23175 18.9103L7.16675 18.0003C7.16675 15.6278 7.34008 13.8837 7.64341 12.7678C7.91425 11.7928 8.54258 11.1645 9.51758 10.8937C10.0267 10.7528 10.9584 10.6553 12.3884 10.5903C13.7967 10.5145 15.0859 10.482 16.2776 10.482L18.0001 10.417C22.5392 10.417 25.3667 10.5903 26.4826 10.8937C27.4576 11.1645 28.0859 11.7928 28.3567 12.7678Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcSocYt);
export default __webpack_public_path__ + "static/media/tc_soc_yt.8154b37f1ede9ccb3a001e7576176ba9.svg";
export { ForwardRef as ReactComponent };